var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPmDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.496094 3.58447H8.3865",
    stroke: "#EA5454",
    strokeWidth: 0.986301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97307 11.2273H2.49362C2.34446 11.2273 2.19677 11.1979 2.059 11.1408C1.92122 11.0836 1.79607 10.9998 1.69071 10.8942C1.58536 10.7887 1.50187 10.6633 1.44501 10.5254C1.38815 10.3875 1.35905 10.2398 1.35938 10.0906V3.5835H7.52376V10.0906C7.52409 10.2398 7.49498 10.3875 7.43813 10.5254C7.38127 10.6633 7.29778 10.7887 7.19243 10.8942C7.08707 10.9998 6.96192 11.0836 6.82414 11.1408C6.68637 11.1979 6.53868 11.2273 6.38952 11.2273H3.97307Z",
    stroke: "#EA5454",
    strokeWidth: 0.986301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33008 5.43359V9.3788",
    stroke: "#EA5454",
    strokeWidth: 0.986301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54883 5.43359V9.3788",
    stroke: "#EA5454",
    strokeWidth: 0.986301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29043 1.40283H2.5918V3.58552H6.29043V1.40283Z",
    stroke: "#EA5454",
    strokeWidth: 0.986301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmDeleteIcon);
export default __webpack_public_path__ + "static/media/pm-delete-icon.2a097ddb3e7139ab696a1c4bc5cbf3f3.svg";
export { ForwardRef as ReactComponent };